const orderedProductsById = [
  'CP-PANEL-345-1',
  'CPA-HUB-345-1',
  'CPA-PANEL-345-1',
  'window-sticker-sm',
  'perkspot-the-essentials',
  'perkspot-the-stronghold',
  'CP-YS-23i-1',
  'CP-DS-345-1',
  'CP-WS-345-1',
  'RE607',
  'CP-PIR-345-1',
  '2G-GB-345-1',
  'secondary-siren',
  '2GIG-CO8-345',
  'CP-SCC01-345-1',
  // '2G-SHF-345-1',
  '2GIG-SMKT8-345',
  // '2G-CO-345-1', // CO Detector
  'CP-FS-345-1',
  'CP-KEY-345-1',
  'CP-MED-345-1',
  'CP.Y20BA',
  'SKY.TRIM2.S',
  'indoor-camera-eufy',
  'doorbell-camera-eufy',
  'outdoor-camera-eufy',
];

export default orderedProductsById;
